document.addEventListener('DOMContentLoaded', () => {

  const featured = document.getElementById('vpFeaturedImage');

  const thumbs = document.querySelectorAll('.vp-thumb');

  thumbs.forEach((thumb) => {

    thumb.addEventListener('click', () => {

      featured.setAttribute('src', thumb.dataset.image);
featured.removeAttribute('srcset');

      thumbs.forEach((t) => {
        t.classList.remove('active');
      });

      thumb.classList.add('active');

    });

  });
const qtyInput = document.querySelector('.vp-quantity-box input');
const minus = document.querySelector('.vp-minus');
const plus = document.querySelector('.vp-plus');

if (qtyInput && minus && plus) {

  minus.addEventListener('click', () => {
    let value = parseInt(qtyInput.value) || 1;
    if (value > 1) qtyInput.value = value - 1;
  });

  plus.addEventListener('click', () => {
    let value = parseInt(qtyInput.value) || 1;
    qtyInput.value = value + 1;
  });

}
});
